module.exports = __webpack_public_path__ + "img/logo.a323104d.png";